module.exports = function getResource(label) {
    const resources = {
        gotIt: 'Compris',
        basketUrgencyMessage: 'Les articles dans votre panier ne sont pas réservés jusqu’au paiement.'
    };

    return resources[label];
};
